<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .page-subscription

        &__column
            display: flex
            flex-direction: column

            header
                +media('>large')
                    min-height: $baseline*9

            .body--column.card
                .title--2
                    margin-bottom: $baseline*1.75
                    text-align: center
                .image
                    height: 4rem
                    display: block
                    margin: -1.75rem auto 1rem

        &__links
            display: flex
            flex-direction: column
            align-items: center
            > * + *
                margin-top: .75em

        &__mention
            margin: $baseline*2 0
            text-align: center
            p
                font-size: .75rem

</style>

<script>
export default {}
</script>
